import RecurringEarningsWidget from './RecurringEarningsWidget.jsx';

export default RecurringEarningsWidget;
